import axios from 'axios'
import { ApiConfig } from '../../../../config/api'
import { LpnState } from '../../../PutAway/types/enums'

export const getLpnState = (
  asnId: number,
  page = 0,
  pageSize = 5,
  orderBy?: { field: string; direction: string }
) => {
  const url = new URL(`${ApiConfig.AsnDetailApi}/GetAsnDetailLpnState`)

  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  url.searchParams.set('asnId', asnId.toString())

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

export const PatchLpnState = (asnId: number, lpn: string) => {
  const url = new URL(`${ApiConfig.AsnDetailUpdateLpnState}/${asnId}`)
  const lpnStatePending = LpnState.Pending
  return axios.patch(url.toString(), { lpn: lpn, LpnStateId: lpnStatePending })
}
